// extracted by mini-css-extract-plugin
export default {"menu-item":"MenuItem_menu-item__+0QgL"};